import { render, staticRenderFns } from "./CategoryManageTable.vue?vue&type=template&id=00e5ffa8&scoped=true&"
import script from "./CategoryManageTable.vue?vue&type=script&lang=js&"
export * from "./CategoryManageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e5ffa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VFlex})
